export default "__VITE_ASSET__2722ea77__"